import React from 'react';
import { Tooltip, TooltipProps } from '@mui/material';

export const MobileTooltip = ({ children, ...props }: TooltipProps) => (
  <Tooltip
    {...props}
    enterTouchDelay={50}
    leaveTouchDelay={3000}
  >
    {children}
  </Tooltip>
);
